let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lJsyV")).then(() => parcelRequire('f4kLw'));